import { render, staticRenderFns } from "./autoSms.vue?vue&type=template&id=bb06c7c8&"
import script from "./autoSms.vue?vue&type=script&lang=js&"
export * from "./autoSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports